module.exports = __webpack_public_path__ + "media/packs/images/markers/mix-bbb2caf698c270ee863f6036a6c395d0.svg";